export const getWidgetContainerStyles = (isFullWidth: boolean | undefined) => (isFullWidth ? 'span 4' : 'span 2')
